import { motion } from "framer-motion";

export default function AnimatedTitle({ children, className, style = {} }) {
  return (
    <motion.h2
      className={className}
      style={style}
      initial={{ opacity: 0, y: 60, scale: 0.95 }}
      whileInView={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      viewport={{ once: true, amount: 0.8 }}
    >
      {children}
    </motion.h2>
  );
}
